export { MainPrayerSection } from './main-prayer-section';
